/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato della rendicontazione di un esercente in un periodo
 */
export enum RendicontazioneEsercenteStatus {

    DA_SOTTOMETTERE = 'DA_SOTTOMETTERE',

    SOTTOMESSA = 'SOTTOMESSA',

    ACCETTATA = 'ACCETTATA',

    PAGATA = 'PAGATA',

    RIFIUTATA = 'RIFIUTATA'
}

